/* eslint-disable default-param-last */

import {setFleetDriversTagsStatus } from '../../actions/common';
import saveFetch from '../../features/utils/saveFetch';
import { env } from '../../env';

const { TACHOGRAPH_SERVICES_SERVICE } = env.runtimeConfig.backend;

const getFleetDriversTagStatus = (
    store,
    fetch = window.fetch,
) => () => fetch(
    `${TACHOGRAPH_SERVICES_SERVICE}/downloadscheduler/fleet-drivers-tag-synced`,
    {
        headers: {
            Authorization: `Bearer ${`${store.getState().tokenHandling.accessToken}`}`,
        },
        method: 'GET',
    },
);

export const getHandleData = store => data => {
    store.dispatch(setFleetDriversTagsStatus(data));
};

const configureFetchFleetDriversTagStatus = store => new Promise(resolve => {
    const fleetDriversTagStatus = getFleetDriversTagStatus(store);

    saveFetch(
        fleetDriversTagStatus,
        'Fleet Drivers Tags Status',
        getHandleData(store),
        resolve,
        () => {},
    );
});

export default configureFetchFleetDriversTagStatus;
